import rootSaga from './sagas';
import reducers from './reducers';
import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '../api/baseApi';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: {
        ...reducers,
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(sagaMiddleware, baseApi.middleware),
});

sagaMiddleware.run(rootSaga);

export default store;
